import React, { useMemo } from 'react';
import useTheme from '../theme';
const Logo = ({ variant = 'dark', width = '4.25rem', height = '1.3125rem', styles = {} }) => {
    const { colors } = useTheme();
    const color = variant === 'light' ? colors.neutrals.background : colors.neutrals.textAlpha;
    const mergedStyles = useMemo(() => ({
        width,
        height,
        ...styles
    }), [width, height, styles]);
    return (React.createElement("svg", { viewBox: "0 0 68 21", style: mergedStyles },
        React.createElement("path", { fill: color, d: "M3.03 1.17H0V19h3.03v-7.53h9.47V19h3.04V1.17H12.5v7.4H3.03zm17.65 10.29h8.18V8.59h-8.18V4.04h10V1.17H17.65V19h13.19v-2.87H20.68z" }),
        React.createElement("g", { transform: "translate(32.34 .2)" },
            React.createElement("path", { fill: color, d: "M25.67 16.2c-3.61 0-6.13-2.6-6.13-6.31 0-3.72 2.52-6.32 6.13-6.32 3.6 0 6.2 2.6 6.2 6.32s-2.6 6.31-6.2 6.31M9.77 8.6H3.23V3.75h6.56c1.57 0 2.46.9 2.46 2.33 0 1.57-.86 2.52-2.46 2.52M25.67.64c-5.3 0-9 3.8-9 9.25 0 1.74.5 3.44 1.44 4.9l.23.37c-.05.03-.32.22-.72.42a4.67 4.67 0 01-5.8-.9 5.9 5.9 0 01-1.55-3.32l.07-.01c3.03-.44 4.79-2.56 4.79-5.18 0-2.28-1.28-5.2-4.83-5.2H.2V18.8h3.03V11.4h3.8c0 .55.64 5.23 5.15 7.21a8.56 8.56 0 008.29-1.28l.14.11a8.8 8.8 0 005.07 1.71c5.4 0 9.31-3.89 9.31-9.25 0-5.36-3.92-9.26-9.31-9.26" }))));
};
export default Logo;
//# sourceMappingURL=index.js.map